import { useState } from 'react';
import { UseForm } from './useForm.interface';

export const useForm = (form: any): UseForm => {
  const [inputFields, setInputFields] = useState<any>(form);

  const handleChange = (value: string | null, name: string): void => {
    setInputFields({
      ...inputFields,
      [name]: {
        ...inputFields[name],
        value,
      },
    });
  };

  const resetInputFields = (): void => {
    setInputFields(form);
  };

  const handleSelect = (selectedItem: any, value: string, name: string): void => {
    setInputFields({
      ...inputFields,
      [name]: {
        ...inputFields[name],
        selected: selectedItem,
        value,
      },
    });
  };

  return { inputFields, handleChange, setInputFields, handleSelect, resetInputFields };
};
